var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 429,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint0_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF",
    offset: 0.22396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3C46",
    offset: 0.93229
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint1_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF",
    offset: 0.22396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3C46",
    offset: 0.91146
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint2_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "#345DAF",
    offset: 0.88021
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint3_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF",
    offset: 0.22396
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.04,
    stopColor: "#345DAF",
    offset: 0.78646
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint4_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF88",
    offset: 0.04688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2875A3",
    offset: 0.44792
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 1,
    x2: 0.5,
    y1: 0,
    x1: 0.5,
    id: "paint5_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AAA84",
    offset: 0.11979
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF",
    offset: 0.66667
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0,
    x2: 0.5,
    y1: 1,
    x1: 0.5,
    id: "paint6_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "#345DAF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0,
    x2: 0.5,
    y1: 1,
    x1: 0.5,
    id: "paint7_linear"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#345DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.04,
    stopColor: "#345DAF",
    offset: 0.77604
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    fill: "url(#paint0_linear)",
    rx: 37.5,
    height: 161,
    width: 75,
    y: 196,
    x: 184
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    fill: "url(#paint1_linear)",
    rx: 37.5,
    height: 217,
    width: 75,
    y: 196,
    x: 265
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_3",
    fill: "url(#paint2_linear)",
    rx: 35.5,
    height: 102,
    width: 71,
    y: 198,
    x: 186
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_4",
    fill: "url(#paint3_linear)",
    rx: 35.5,
    height: 139,
    width: 71,
    y: 198,
    x: 267
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "url(#paint4_linear)",
    d: "m22,147.5c0,-20.711 16.7893,-37.5 37.5,-37.5l0,0c20.7107,0 37.5,16.789 37.5,37.5l0,86c0,20.711 -16.7893,37.5 -37.5,37.5l0,0c-20.7107,0 -37.5,-16.789 -37.5,-37.5l0,-86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "url(#paint5_linear)",
    d: "m103,91.5c0,-20.7107 16.789,-37.5 37.5,-37.5l0,0c20.711,0 37.5,16.7893 37.5,37.5l0,142c0,20.711 -16.789,37.5 -37.5,37.5l0,0c-20.711,0 -37.5,-16.789 -37.5,-37.5l0,-142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "url(#paint6_linear)",
    d: "m24,233.5c0,19.606 15.8939,35.5 35.5,35.5l0,0c19.6061,0 35.5,-15.894 35.5,-35.5l0,-31c0,-19.606 -15.8939,-35.5 -35.5,-35.5l0,0c-19.6061,0 -35.5,15.894 -35.5,35.5l0,31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "url(#paint7_linear)",
    d: "m105,233.5c0,19.606 15.894,35.5 35.5,35.5l0,0c19.606,0 35.5,-15.894 35.5,-35.5l0,-67c0,-19.606 -15.894,-35.5 -35.5,-35.5l0,0c-19.606,0 -35.5,15.894 -35.5,35.5l0,67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/appLogo.4a73fa793ff74b1141a5ba9daa365e86.svg";
export { ForwardRef as ReactComponent };